import fetch from 'isomorphic-fetch';

const START_LOADING = 'contact-us/START_LOADING';
const SEND_MAIL_SUCCESS = 'contact-us/SEND_MAIL_SUCCESS';
const SEND_MAIL_FAIL = 'contact-us/SEND_MAIL_FAIL';

const initialState = {
  fetching: false,
  values: {},
  error: ''
};

/* *********** Reducer ************/

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        fetching: true
      };
      break;
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        values: {},
        fetching: false,
        error:''
      };
      break;
    case SEND_MAIL_FAIL:
      return {
        ...state,
        values: action.data,
        fetching: false,
        error: action.error
      };
      break;
    default:
      return state;
  }
}


/* *********** Actions ************/

export function startLoading() {
  return {
    type: START_LOADING
  };
}

export function sendFail(error, data) {
  return {
    type: SEND_MAIL_FAIL,
    error,
    data
  };
}

export function sendSuccess() {
  return {
    type: SEND_MAIL_SUCCESS
  };
}


/* *************** Async Actions******************** */


const headers = () => ({
  'Content-Type': 'application/json',
  'X-Skip-Subdomain-Redirect': 'true'
});

export function asyncSendMail(data) {
  return (dispatch) => {
    dispatch(startLoading());
    const options = {
      method: 'PUT',
      body: JSON.stringify(data)
    };
    options.headers = headers();

    return fetch('send-email.php', options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sendSuccess());
        } else {
          dispatch(sendFail('Server error', data));
        }
        return response;
      })
      .catch((error) => {
        dispatch(sendFail(error, data));
      });
  };
}


// WEBPACK FOOTER //
// ./src/redux/modules/contat-us.js